<shared-external-cmr-agent-bar [showButtonBack]="showButtonBack" [tenantId]="value ? value.tenantId : ''"
    (clickBack)="onClickBack()"></shared-external-cmr-agent-bar>
<ng-container *ngIf="!uuidQR">
    <div class="block-center">
        <div class="header"></div>
        <div class="nouuid">
            No valid uuid
        </div>
    </div>
</ng-container>

<div class="container qrcmr">
    <div class="block-center">
        <ng-container *ngIf="(optionExpanded=='' || optionExpanded==null)">
            <div class="info-partner driver">
                <i class="fa fa-user-circle" aria-hidden="true"></i>
                {{ 'SHARED.EXTERNAL.CMR.AGENT.DRIVER.TITLE' | translate }}
            </div>
            <shared-ecmrs-qr-component [qrdownload]="true" [uuidQR]="uuidQR" [helpResource]="'SHARED.QR.CMR.HELP'"></shared-ecmrs-qr-component>
            <div *ngIf="value">
                <div class="route-description">
                    {{'SHARED.EXTERNAL.CMRS.TITLE' | translate:{ value: getCount() } }}
                </div>
                <div class="buttons-group">
                    <ng-container *ngFor="let phase of value.phases | sortBy:'executionOrder'">
                        <div class="action-card"
                            [ngClass]="{'card-collect': phase == null || phase.isLoad, 'card-deliver': phase != null && phase.isUnload}"
                            (click)="goToPhase(phase)">
                            <div class="icon-wrapper">
                                <i class="fa fa-upload" aria-hidden="true" *ngIf="phase == null || phase.isLoad"></i>
                                <i class="fa fa-download" aria-hidden="true" *ngIf="phase != null && phase.isUnload"></i>
                            </div>
                            <div class="card-body">
                                <div class="card-title">{{phase.addressTitle}}</div>
                                <div class="card-desc">{{ phase.addressLine1 }}</div>
                            </div>
                            <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
                        </div>
                    </ng-container>
                    <div class="action-card card-actions" (click)="onClickLinkOption('Actions')">
                        <div class="icon-wrapper">
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </div>
                        <div class="card-body">
                            <div class="card-title">{{'SHARED.EXTERNAL.CMR.ACTIONS.CAPTION' | translate }}</div>
                        </div>
                        <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
                    </div>
                    <div class="action-card card-event" (click)="onClickLinkOption('Events')">
                        <div class="icon-wrapper">
                            <i class="fa fa-history" aria-hidden="true"></i>
                        </div>
                        <div class="card-body">
                            <div class="card-title">{{'SHARED.EXTERNAL.CMR.EVENTS.CAPTION' | translate }}</div>
                        </div>
                        <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </ng-container>
        <shared-external-cmr-agent-phase-ecmrs-digitaldocument *ngIf="optionExpanded=='Phase'" [phaseUUID]="phaseUUID" [agent]="'driver'">
        </shared-external-cmr-agent-phase-ecmrs-digitaldocument>
        <shared-external-cmr-agent-actions *ngIf="optionExpanded=='Actions'" [uuidQR]="uuidQR" [agent]="'driver'">
        </shared-external-cmr-agent-actions>
        <shared-external-cmr-agent-events *ngIf="optionExpanded=='Events'" [uuidQR]="uuidQR" [agent]="'driver'">
        </shared-external-cmr-agent-events>
    </div>
</div>
<div class="signaturahardman">
    <img class="logoimg" src="/assets/images/HardmanLogoBlanc.png" alt="Hardman logo">
    <a href="https:hardman.app" target="_blank" class="powered">{{'GLOBAL.DESENVOLUPATPER' | translate}}</a>
</div>